export const Primary = "#E13B30";
export const Secondary = "#F7CECB";
export const Focused = "#F09D97";
export const Yellow = "#E6B558";
export const Red = "#BF0013";
export const Green = "#219653";
export const Blue = "#005FCC";
export const White = "#FFFFFF";
export const White01 = "#F3F1F2";
export const GreyStroke = "#D8D8DC";
export const Grey = "#BCBCC0";
export const DarkGrey = "#6C6C70";
export const Black = "#252525";
export const WallPlast = "#8C8952";
export const Violet = "#6326DF";
